import {EditTariffPlans} from './edit-tariff-plans';

export default EditTariffPlans;